const { ENV, ENV_HACKERONE } = require('./helpers/environment')

const config = {
	development: {
		SupportedLanguages: ['en', 'es', 'pt', 'de', 'it', 'fr', 'sv', 'es-419', 'pl', 'tr', 'nl', 'da', 'nb'],
		AbSmartlyApiHost: 'https://simple.absmartly.io',
		AbSmartlyApiKey: '2HkWTYAWpZGDabCrX_Dx4gAJpw-CF5j4QcZXLSSKxCpclQmido5k7qKMuZuu70zd',
		Amplitude: '8f6140c4e71822f942f0b4ce6f5f4a59',
		AmplitudePaltaWeb: '2f3a8a3d04de1a14bb085afc5d21258d',
		GTMMainContainer: 'GTM-MZ8NBTM',
		GTMActivityContainer: 'GTM-MZ8NBTM',
		Braintree: 'sandbox_tvkjxp3z_c26s349gchcx25ct',
		OnetrustApiKey: 'f408777c-6bdf-4ff7-bfc6-6bdea2869b6e-test',
		OnetrustNoFastingApiKey: 'f4b4caa1-288c-44b8-a77f-16a29773e147-test',
		PaltaApiUrl: 'https://api.payments.simple.paltabrain.com',
		PaltaApiKey: 'feefe9c57a314b0bbc7baeab1eb79c41',
		StrapiCMS: 'https://strapi.fstr.app',
		StrapiQA: 'https://strapi.dev.fstr.app/',
		StrapiS3: 'https://strapi.cdn-simple-life.com',
		Stripe: 'pk_test_yEFUsiwhzwEHQDozzGNw6j6a00UXWSg0nY',
		BrazeApiKey: 'f164faaf-179f-4102-83d8-8638a0d78f0a',
		BrazeCanvasApiKey: '09f74117-f3b2-492f-a0a8-1c35c6ecc4a0',
		BrazeCampaignApiKey: 'ddbfa2c2-1912-403b-97b1-5db8a6d29f7b',
		BrazeSdkEndpoint: 'sdk.iad-05.braze.com',
		BrazeWorkbooksBundleCanvasId: '62064bd6-caad-4f15-accb-4478e10ec0b9',
		BrazeWorkbooksBundlePlusOfferCanvasId: '2fcfb4c4-4383-4082-80b8-e370f029da61',
		BrazeEmotionalCourseCanvasId: '4207ae35-4dac-8f83-3e62-d2635435844f',
		BrazeNewFunnelWorkbooksCampaignID: '0346f101-f540-49a0-b945-e3dac162842e',
		BrazePersonalizedUpsellWorkoutCanvasId: 'b47f64ee-e295-4ed2-9384-92777190c513',
		BrazePersonalizedUpsellEmotionalEatingCanvasId: '2fcba282-863a-4c5f-8f38-aa5932d608fb',
		BrazePersonalizedUpsellBundleCanvasId: '6d3f01a1-cd50-4d5f-b058-6cf227a02a7f',
		BrazeMealPlanDessertSubscriptionCanvasId: '7ed5fc6c-0b20-dfb9-6a6f-da3f03c166c5',
		BrazeMealPlanSubscriptionCanvasId: 'f4d4251f-3fb2-0458-e93b-a0444ed27530',
		BrazeZingBodyScanCampaignId: '8360001b-1129-6708-1c0b-5d1c386afc6a',
		BrazeAssessmentAndWeightLossCanvasId: '0ad817c6-6dae-41d7-aef6-1c27470a3b50',
		FstrAPIUrl: 'https://rest.dev.fstr.app/v1',
		FstrUsersAPIUrl: 'https://rest.dev.fstr.app/users/api/',
		SimpleAPIUrl: 'https://payment-api-dev.simple.life/',
		MarketingAPIUrl: 'https://capi.dev.fstr.app/v1',
		GeoAPIUrl: 'https://assets.simple.life/geo.json',
		FeatureFlagsUrl: 'https://configs.cdn-simple-life.com/content-api/dev/feature_flags.json',
		ApiLocalization: 'https://i18n.cdn-simple-life.com/dev/i18n/',
		AssetsPublicUrl: 'https://assets.simple.life/',
		MlChurnPredictAPIUrl: 'https://churn-predict.dev.fstr.app/',
		MlChurnPredictApiKey: '123',
		stripe_product_id: 'prod_GW5JdBN2r8HlOJ',
		stripe_introductory: 'prod_MYH1pNY399u6n7',
		stripe_introductory_workbooks_plus_offer: 'prod_NcxwrJjliVs3hF',
		stripe_cheap_and_short: 'prod_NuEdBJJQBl9WMO',
		stripe_cheap_and_short_1_month: 'prod_OlhTy9tPOtVIcQ',
		stripe_cheap_and_short_3_month: 'prod_OlhUuJspakGMsr',
		stripe_cheap_and_short_1_year: 'prod_OlhVOShdsHkhIL',
		stripe_cheap_and_short_zing: 'prod_Ov7x6wGQ20GDby',
		stripe_cheap_and_short_upgrade_1_year: 'prod_OHOkEYGJklKFSE',
		stripe_cheap_and_short_upgrade_3_month: 'prod_ORsb2kz7jxwfqd',
		stripe_cheap_and_short_upgrade_6_month: 'prod_ORsagwcYh7PCmB',
		stripe_cheap_and_short_upgrade_9_month: 'prod_ORsYD4Y4VMNo4U',
		stripe_cheap_and_short_zing_upgrade: 'prod_Ov83NWwtUj6v6T',
		stripe_meal_plan_subscription: 'prod_NwPzO4k2Oydp1U',
		stripe_upgrade_on_year: 'prod_OHNV3cpO8RWy20',

		EX_DEV_2622_WARMING_UP_EMOTIONAL_COURSE_UPSALES: 'DEV-2622',
		EX_DEV_4897_CHANGE_UI_STORIES: 'DEV-4897',
		EX_DEV_4804_FAKEDOOR_FITNESS_TRACKER: 'DEV-4804',
		EX_DEV_4891_FAKEDOOR_SMART_SCALE: 'DEV-4891',
		EX_DEV_4421_OFFER_INSTEAD_TRIAL: 'DEV-4421',
		EX_DEV_3880_KAIZERKA_ONBOARDING: 'DEV-3880',
		EX_DEV_5361_CARTE_BANCAIRE: 'DEV-5361',
		EX_DEV_5100_FAKEDOOR_SUPPLEMENTS: 'DEV-5100',
		EX_DEV_4017_LINK_BY_STRIPE: 'DEV-4017',
		EX_DEV_5191_FAKEDOOR_SNACKS: 'DEV-5191',
		EX_DEV_5419_VERTEIDIGER_DE: 'DEV-5419-DE',
		EX_DEV_5419_VERTEIDIGER_FR: 'DEV-5419-FR',
		EX_DEV_5190_MEAL_PLAN_WORKBOOK: 'DEV-5190'
	},

	production: {
		SupportedLanguages: ['en', 'es', 'pt', 'de', 'it', 'fr', 'sv', 'es-419', 'pl', 'tr', 'nl', 'da', 'nb'],
		AbSmartlyApiHost: 'https://simple.absmartly.io',
		AbSmartlyApiKey: '2HkWTYAWpZGDabCrX_Dx4gAJpw-CF5j4QcZXLSSKxCpclQmido5k7qKMuZuu70zd',
		Amplitude: '62d757a5d66b608a2149ecda61c4fa9a',
		AmplitudePaltaWeb: '02714fe0df63e6f2d797930ed05998d2',
		GTMMainContainer: 'GTM-MNHMHJD',
		GTMActivityContainer: 'GTM-MSF5SXMW',
		Braintree: 'production_gptpb7ch_433xxb89rdv8fqqg',
		OnetrustApiKey: 'f408777c-6bdf-4ff7-bfc6-6bdea2869b6e',
		OnetrustNoFastingApiKey: 'f4b4caa1-288c-44b8-a77f-16a29773e147',
		PaltaApiUrl: 'https://api.payments.simple.paltabrain.com',
		PaltaApiKey: 'd98b7063d72c475dbfeb03b21146be0d',
		StrapiCMS: 'https://strapi.fstr.app',
		StrapiQA: 'https://strapi.dev.fstr.app/',
		StrapiS3: 'https://strapi.cdn-simple-life.com',
		Stripe: 'pk_live_rPibmqvx4VnIYpYIoBuiy4oL00PGZktmD3',
		FB: '871387013207297',
		AppleClientId: 'com.amapps.simple.web.signin',
		GoogleClientId: '500728569656-of3b8ost6fh8mghk0olr61kam77pjtpv.apps.googleusercontent.com',
		BrazeApiKey: '020304c8-bbbf-4043-8322-b454553bba4d',
		BrazeCanvasApiKey: 'cbe5e595-ce0f-4e22-ba6f-5ccdc0567951',
		BrazeCampaignApiKey: '3ea60a92-6ad9-4588-afe7-5ac2837e1a3f',
		BrazeSdkEndpoint: 'sdk.iad-05.braze.com',
		BrazeWorkbooksBundleCanvasId: '7bf68f70-39a8-4bd8-9ce2-8210e67700d1',
		BrazeWorkbooksBundlePlusOfferCanvasId: '8da9878e-2d64-dad2-edc6-ea9a8eddca9c',
		BrazeEmotionalCourseCanvasId: 'c912fafc-39d4-ae1e-2bd9-87b682417320',
		BrazeNewFunnelWorkbooksCampaignID: '677b9812-471a-4f03-9674-61a48a04589a',
		BrazePersonalizedUpsellWorkoutCanvasId: '8b9c7e88-d214-44e7-b64c-3fc9dec5551f',
		BrazePersonalizedUpsellEmotionalEatingCanvasId: '66a7923f-9e12-4734-91a9-ca272ed1180b',
		BrazePersonalizedUpsellBundleCanvasId: '0ee42372-263b-41e4-8e64-a09697bc7286',
		BrazeMealPlanDessertSubscriptionCanvasId: '1d9522b9-7d67-4cea-b615-3d94e63697b9',
		BrazeMealPlanSubscriptionCanvasId: '6ec6cbc4-beb4-4df3-9983-75a0b9547b17',
		BrazeZingBodyScanCampaignId: '3dcd996a-a9ba-1d32-3b88-b35f19d26117',
		BrazeAssessmentAndWeightLossCanvasId: '88595758-fba2-4fbb-b419-910c5312b485',
		FstrAPIUrl: 'https://rest.fstr.app/v1',
		FstrUsersAPIUrl: 'https://rest.fstr.app/users/api/',
		SimpleAPIUrl: 'https://api.simple.life/',
		MarketingAPIUrl: 'https://capi.fstr.app/v1',
		GeoAPIUrl: 'https://assets.simple.life/geo.json',
		FeatureFlagsUrl: 'https://configs.cdn-simple-life.com/content-api/feature_flags.json',
		ApiLocalization: 'https://i18n.cdn-simple-life.com/i18n/',
		AssetsPublicUrl: 'https://assets.simple.life/',
		MlChurnPredictAPIUrl: 'https://churn-predict.fstr.app/',
		MlChurnPredictApiKey: '123',
		stripe_product_id: 'prod_GgA3GIwzX7x2Wx',
		stripe_introductory: 'prod_MYGmHi1IUfZbZT',
		stripe_introductory_workbooks_plus_offer: 'prod_Ncxf7ShVtRH2zc',
		stripe_cheap_and_short: 'prod_NuuPPCWqACFvaX',
		stripe_cheap_and_short_1_month: 'prod_OlhZHM6P3PcfQj',
		stripe_cheap_and_short_3_month: 'prod_OlhaZcr2PRJmIV',
		stripe_cheap_and_short_1_year: 'prod_Olhb5ZuzjBQXb2',
		stripe_cheap_and_short_zing: 'prod_Ov7zP1sSh82BMg',
		stripe_cheap_and_short_upgrade_1_year: 'prod_OHOaIf5cgshVkT',
		stripe_cheap_and_short_upgrade_3_month: 'prod_ORsxDWFSvGgYRX',
		stripe_cheap_and_short_upgrade_6_month: 'prod_ORswLUtnySYgTl',
		stripe_cheap_and_short_upgrade_9_month: 'prod_ORsvyosF7jYq6x',
		stripe_cheap_and_short_zing_upgrade: 'prod_Ov82IRzjlE7bEf',
		stripe_meal_plan_subscription: 'prod_OAiQ8j7txPNmwG',
		stripe_upgrade_on_year: 'prod_OHhd5BgG2bvOBS',

		EX_DEV_2622_WARMING_UP_EMOTIONAL_COURSE_UPSALES: '0hFjPeojSVKfhfA42YD82g',
		EX_DEV_4897_CHANGE_UI_STORIES: 'VnhJJtxQRwm7swlATLEA-Q',
		EX_DEV_4804_FAKEDOOR_FITNESS_TRACKER: 'KyIfwup0SKOYcR6IUk8vjg',
		EX_DEV_4891_FAKEDOOR_SMART_SCALE: '1VP98d__QgCkN2_LcoBMUQ',
		EX_DEV_4421_OFFER_INSTEAD_TRIAL: 'A3UwTC5ITjequKGL8839cg',
		EX_DEV_3880_KAIZERKA_ONBOARDING: 'NW5eM-WITmuKZAMBt2bIYQ',
		EX_DEV_5361_CARTE_BANCAIRE: 'dPHzZFNeT9uzwL4hMJxXKg',
		EX_DEV_5100_FAKEDOOR_SUPPLEMENTS: 'ozw9FPbURiuRWbz_MtxFuA',
		EX_DEV_5191_FAKEDOOR_SNACKS: 'ePbY6W51T26r-TgkDQtu_w',
		EX_DEV_4017_LINK_BY_STRIPE: 'gqU-3IrdTsy829kvlSFggA',
		EX_DEV_5465_MONTHLY_OFFER: 's8qoUQESRAawuiw-gqn0Pg',
		EX_DEV_5419_VERTEIDIGER_DE: '43-9jSnUSEm_RqzOIJGejA',
		EX_DEV_5419_VERTEIDIGER_FR: '4yKqwe_VRLKGyDc5d5_ULg',
		EX_DEV_5190_MEAL_PLAN_WORKBOOK: 'kInbgajcQTqA0axTon0hUw'
	}
}

module.exports = (option) => {
	if (ENV_HACKERONE) {
		if (option === 'StrapiCMS') {
			return config.production.StrapiCMS
		}

		return config.development[option]
	}

	if (Object.prototype.hasOwnProperty.call(config[ENV], option)) {
		return config[ENV][option]
	}

	return config.production[option]
}
